<template>
  <div style="height: 100%;">
    <router-view></router-view>
    <UpdateModal :visible="showUpdateModal" />
  </div>
</template>

<script>
import UpdateModal from './UpdateModal.vue'

export default {
  name: 'App',
  components: {
    UpdateModal
  },
  data () {
    return {
      showUpdateModal: false
    }
  },
  mounted () {
    // Add global method to show update modal
    window.showUpdateModal = () => {
      this.showUpdateModal = true
    }
  },
  beforeDestroy () {
    // Cleanup global method
    delete window.showUpdateModal
  }
}
</script>
